import React from "react"
import { useFormContext, Controller } from "react-hook-form"
import { isInvalidClass, validationClass, validationMode } from "./CpntFormFieldGroup"
import Label from "./Label"

interface IProps {
    label?: string,
    formName: string,
    placeholder?: string,
    maxLength?: number,
    className?: string;
    rows?: number,
    ismandatory?: boolean,
    popover?: string,
    validationStyle?: validationMode,
    extraOnChange?: (val:string) => void,
    defaultvalue?: string
}
const TextAreaInput: React.FC<IProps> = ({
    formName,
    label = formName,
    ismandatory,
    placeholder,
    maxLength,
    className,
    rows,
    popover,
    validationStyle = validationMode.classic,
    extraOnChange,
    defaultvalue
}) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { getFieldState, watch, getValues, formState: { errors } } = useFormContext();
    const validationClassName = (): string => {
        switch (validationStyle) {
            case validationMode.classic:
                return validationClass(getFieldState(formName).error, !getFieldState(formName).error && getValues(formName));
            case validationMode.invalid:
                return isInvalidClass(getFieldState(formName).error);
            default:
                return "";
        }
    }

    const watchAll = watch()

    return (
        <>
            <Label label={label} htmlFor={formName} errors={getFieldState(formName).error?.message} ismandatory={ismandatory} popover={popover}>
                {/* <textarea
                    id={formName}
                    {...register(formName)}
                    className={`form-control  ${validationClassName()}`}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    rows={rows}
                /> */}
                <Controller
                    render={({ field }) => <textarea
                        id={formName}
                        className={`form-control ${validationClassName()} ${className && className} `}
                        placeholder={placeholder}
                        onChange={(e) => {
                            field.onChange(e)
                            extraOnChange && extraOnChange(e.target.value)
                        }}
                        value={field.value}
                        maxLength={maxLength}
                    rows={rows}
                    />}
                    name={formName}
                    defaultValue={defaultvalue}
                />
            </Label>
            {maxLength && <div className="d-flex justify-content-end">
                <em>
                Nombre de caractères restants : {maxLength - (watchAll?.[formName]?.length || 0)}
                </em>
            </div>}
        </>
    )
}

export default TextAreaInput